(function () {
    'use strict';
    EditableInputController.$inject = ['$scope', '$attrs', '$element', 'AlbumInfo', 'AlbumInfoExtend', 'DataUtils', 'ImageDataExtended', '$timeout'];

    function EditableInputController($scope, $attrs, $element, AlbumInfo, AlbumInfoExtend, DataUtils, ImageDataExtended, $timeout) {
//
        var $ctrl = this;
        $ctrl.mode = 0;
        $ctrl.isReadonly = true;
        $ctrl.gotoEditMode = gotoEditMode;
        $ctrl.confirmEdit = confirmEdit;
        $ctrl.cancelEdit = cancelEdit;
        $ctrl.isEditable = true;
        var oldValue = $ctrl.value;


        function gotoEditMode() {

            var oldValue = $ctrl.value;
            $ctrl.mode = 1;
            $ctrl.isReadonly = false;
        }

        function confirmEdit() {

            var ok = $ctrl.onConfirmEdit({value: $ctrl.value});
            if (ok) {
                $ctrl.mode = 0;
                $ctrl.isReadonly = true;
            }
        }

        function cancelEdit() {

            $ctrl.value = oldValue;
            $ctrl.mode = 0;
            $ctrl.isReadonly = true;
        }


    }


    var EditableInput = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/editable-input/eyeson.editable-input.html',
        controller: EditableInputController,
        bindings: {
            value: '=',
            onConfirmEdit: '&',
            isEditable: '<?'

        }

    };

    angular
        .module('tikonApp')
        .component('eoEditableInput', EditableInput)


})();

